module.exports = __webpack_public_path__ + "static/publicwifi-a2a75fe7ba8e68f214000ef95bf97a91.svg";